import React, { useEffect, useState,useRef } from "react";
import { CSVLink } from "react-csv";
import { BrandsTypes, toLakhs } from "../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import Select from "react-select";
import ScrollContainer from "react-indiana-drag-scroll";
import SheetTwoLoader from "./SheetTwoLoader";
import TableLoader from "../../../shared/TableLoader";
import NoDataFound from "../../../shared/NoDataFound";

const SheetTwoPreview = ()=>{
  const now = new Date();
  const currentYear = now.getFullYear();
  
  // Start of current year (Jan 1, 00:00:00)
  const startOfThisYear = new Date(currentYear, 0, 1);
  startOfThisYear.setHours(0, 0, 0, 0);
  
  // End of current year (Dec 31, 23:59:59)
  const endOfThisYear = new Date(currentYear, 11, 31);
  endOfThisYear.setHours(23, 59, 59, 999);
  
  // Start of previous year (Jan 1, 00:00:00)
  const startOfLastYear = new Date(currentYear - 1, 0, 1);
  startOfLastYear.setHours(0, 0, 0, 0);
  
  // End of previous year (Dec 31, 23:59:59)
  const endOfLastYear = new Date(currentYear - 1, 11, 31);
  endOfLastYear.setHours(23, 59, 59, 999);
  
  const [MonthRange, setMonthRange] = useState([startOfThisYear, endOfThisYear]);
  const [compareMonthRange, setcompareMonthRange] = useState([startOfLastYear, endOfLastYear]);
  
    const [brandtype,setbrandtype] = useState(2);//local-telugu
    const [salesList, setsalesList] = useState([]);
    const [salesId, setsalesId] = useState([]);
    const [ data, setData] = useState({});   
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [Locations, setLocations] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const csvLinkRef = useRef(null);
    const formatMonthRangeLabel = (range) => {
      if (!range || range.length === 0 || !range[0]) return "";
    
      const start = new Date(range[0]);
      const end = new Date(range[1] || range[0]);
    
      const format = (d) =>
        d.toLocaleString("en-US", { month: "short", year: "numeric" }); // e.g. "Jan 2024"
    
      if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
        return format(start); // single month (e.g. "Apr 2025")
      }
    
      return `${format(start)} - ${format(end)}`; // range (e.g. "Jan 2024 - Jul 2024")
    };
    
    const getSales = async () => {
      try {
        let res = await API({
          url:"/planning/getSales",
          method:'POST',
          responseType:'json',
          data:{
            type:brandtype
          }
        })
        if(res.code === 200){
          const formatted = res.data.map((item) => ({
            value: item.sales_person_id,
            label: item.name
          }));
          setsalesList(formatted)
        }
      } catch (error) {
        console.error(error);
      }
    }
    const handleFetch = async () => {
        try {
          const result = await API({
            url: "/phionex_reports/getSheet2Data",
            method: "POST",
            data: { 
                selectedmonth: MonthRange,
                comparemonth: compareMonthRange,
                region:selectedLocation,
                brand_type:brandtype,
                salesId:salesId.length > 0 ? salesId : null,
             },
          });
          if (result.status === "SUCCESS") {
            return result.data;
          } else {
            Toast("error", result?.message || "Failed To Fetch Data");
            return {};
          }
        } catch (error) {
          Toast("error", "An error occurred");
          return {};
        }
      };
    useEffect(() => {
        const fetchLocations = async () => {
          const result = await API({
            url: "/phionex_reports/brandLocations",
            method: "POST",
          });
    
          if (result.status === "SUCCESS") {
            setLocations(result.data || []);
          } else Toast("error", "Failed To Get Locations");
        };
        fetchLocations();
    }, []);
    useEffect(()=>{
      if(brandtype)
      {
        getSales();
      }
      else
      {
        setsalesId([]);
        setsalesList([]);
      }
    },[brandtype])
    useEffect(() => {
        const fetchData = async () => {
          setIsLoading(true);
          const result = await handleFetch()
          setData(result);
          setIsLoading(false);
        };
        fetchData();
    }, [MonthRange,compareMonthRange,brandtype,selectedLocation,salesId]);


      const calculateGrowth = (prev, curr) => {
        if (prev === 0 || curr === 0) return "-"
        return Math.round(((curr - prev) / prev) * 100); // standard % growth
      };

      const handlePrepareCSV = () => {
        if (!data || data.length === 0) return;
      
        const compareLabel = formatMonthRangeLabel(compareMonthRange);
        const selectedLabel = formatMonthRangeLabel(MonthRange);
      
        const totalCompare = data.reduce((sum, r) => sum + (r.compare || 0), 0);
        const totalSelected = data.reduce((sum, r) => sum + (r.selected || 0), 0);
        const totalGrowth = calculateGrowth(totalCompare, totalSelected);
      
        const csvRows = data.map(({ region, compare, selected }) => ({
          Region: region,
          [`W2N Spent (${compareLabel})`]: compare,
          [`W2N Spent (${selectedLabel})`]: selected,
          "Total Growth (%)": calculateGrowth(compare, selected),
        }));
      
        csvRows.push({
          Region: "Total",
          [`W2N Spent (${compareLabel})`]: totalCompare,
          [`W2N Spent (${selectedLabel})`]: totalSelected,
          "Total Growth (%)": totalGrowth,
        });
      
        setCsvData(csvRows);
      };
      
      useEffect(() => {
        if (csvData.length > 0) {
          csvLinkRef.current.link.click();
          setCsvData([]); // reset to prevent repeated downloads
        }
      }, [csvData]);
    return(
        <div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-wrap items-center gap-6">

            <div className="flex items-center gap-3">
                <span className="font-semibold whitespace-nowrap">Location:</span>
                <Select
                  options={Locations}
                  value={Locations.find((loc) => loc.value === selectedLocation) || null}
                  onChange={(option) => setSelectedLocation(option ? option.value : null)}
                  isClearable
                  className="min-w-[200px]"
                />
              </div>

              <div className="flex items-center gap-3">
                <span className="font-semibold whitespace-nowrap">Brand Type:</span>
                <Select
                  className="min-w-[200px]"
                  placeholder="Select Brand Type"
                  name="queryAdType"
                  size="medium"
                  value={BrandsTypes.find((option) => option.value === brandtype) || null}
                  onChange={(selected) => {
                    setbrandtype(selected ? selected.value : null);
                  }}
                  options={BrandsTypes}
                  isClearable
                />
              </div>

              <div className={`flex items-center gap-3 ${brandtype ? "" : "opacity-50 pointer-events-none"}`}>np
              <span className="font-semibold whitespace-nowrap">Sales Person:</span>
              <Select
                className="min-w-[220px]"
                placeholder="Select Sales Person"
                options={salesList}
                value={salesList.filter((opt) => salesId?.includes(opt.value))}  // ✅ show selected values
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  setsalesId(values);
                }}
                isMulti
                isClearable
              />
            </div>
          </div>

            <div className="flex flex-wrap items-center gap-6">

              <div className="flex items-center gap-3">
                <span className="font-semibold whitespace-nowrap">Compare Month:</span>
                <DatePicker
                  selected={compareMonthRange[0]}
                  onChange={(update) => setcompareMonthRange(update)}
                  startDate={compareMonthRange[0]}
                  endDate={compareMonthRange[1]}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selectsRange
                  className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                  maxDate={new Date()}
                />
              </div>

              <div className="flex items-center gap-3">
                <span className="font-semibold whitespace-nowrap">Select Month:</span>
                <DatePicker
                  selected={MonthRange[0]}
                  onChange={(update) => setMonthRange(update)}
                  startDate={MonthRange[0]}
                  endDate={MonthRange[1]}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selectsRange
                  className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                  maxDate={new Date()}
                />
              </div>

              <CSVLink
              data={csvData}
              filename={`phionex_reports_sheet2.csv`}
              className="hidden"
              ref={csvLinkRef}
            />

           {data && data.length >0 &&  <button
              onClick={handlePrepareCSV}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Download CSV
            </button>}
            </div>
      </div>

       <ScrollContainer>
          <div className="space-y-2 mb-25">
            <div className="w-full flex items-center justify-center space-x-8">
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f4f4f4", textAlign: "left" }}>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Region</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>W2N Compare Spent ({formatMonthRangeLabel(compareMonthRange)})</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>W2N Selected Spent ({formatMonthRangeLabel(MonthRange)})</th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>Total Growth (%)</th>
                </tr>
              </thead>
              {!isLoading && data && data.length > 0 ? (<tbody>
                {data.map(({ region, compare, selected }) => {
                  const growth = calculateGrowth(compare, selected);

                  return (
                    <tr key={region}>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{region}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }} title={compare}>
                        {toLakhs(compare)}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }} title={selected}>
                        {toLakhs(selected)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color:
                            growth === "-" ? "black" : growth >= 0 ? "green" : "red",
                        }}
                      >
                        {growth === "-" ? "-" : `${growth}%`}
                      </td>
                    </tr>
                  );
                })}
                {(() => {
                  const totalCompare = data.reduce((sum, r) => sum + (r.compare || 0), 0);
                  const totalSelected = data.reduce((sum, r) => sum + (r.selected || 0), 0);
                  const totalGrowth = calculateGrowth(totalCompare, totalSelected);

                  return (
                    <tr
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        borderTop: "2px solid #aaa",
                      }}
                    >
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>Total</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }} title={totalCompare}>
                        {toLakhs(totalCompare)}
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }} title={totalSelected}>
                        {toLakhs(totalSelected)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          color:
                            totalGrowth === "-" ? "black" : totalGrowth >= 0 ? "green" : "red",
                        }}
                      >
                        {totalGrowth === "-" ? "-" : `${totalGrowth}%`}
                      </td>
                    </tr>
                  );
                })()}
              </tbody>)
              : !isLoading && data && data.length === 0 ? (
                <NoDataFound colspan="4" />
            ) : (
                <TableLoader colspan="4"/>
            )}
            </table>
            </div>
          </div>
          </ScrollContainer>
        </div>
    )
}
export default SheetTwoPreview;